module.exports = __webpack_public_path__ + "img/play.19aba91e.png";